import {useTouch} from "../../hooks";
import {useNavigate} from "react-router-dom";
import React from "react";

export function TextWithButtonLink({value = "", label, to, tip}) {
    const touch = useTouch()
    const navigate = useNavigate()
    return <div className="text-start d-flex align-items-center justify-content-between my-2 px-1 hover-bg-secondary-subtle rounded"
                onClick={() => navigate(to)}>
        <div className="d-flex flex-column">
            <div className="text-capitalize fw-semibold">{label}</div>
            {tip && <div className={`fw-light ${touch ? "text-primary" : ""}`}>{tip}</div>}
        </div>
        <div>{touch ? value : `Manage ${value}`} <i className="bi bi-chevron-right"/></div>
    </div>
}
